/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
export function getLottie () {
  return import(/* webpackChunkName: "lottie", webpackPreload: true */ 'lottie-web').then(({ default: lottie }) => lottie)
}
